import Phaser from 'phaser';
import { CHEST, BULLET_BUFF, type BulletBuffKind } from '../config/GameConfig';

/**
 * BuffChest —— 元素 buff 箱子（独立于普通金宝箱）
 *
 * 玩家撞到 = 立即获得 8s 限时弹药效果（fire/ice/chain），不计入升级阈值。
 * 与 Chest 的区别：
 *   - 颜色随 buff 种类（红 / 青 / 紫）
 *   - 中央有对应元素图标（火苗 / 雪花 / 闪电）
 *   - 不进 chestGroup（避免触发升级阈值）
 *
 * 贴图由 [AssetFactory.buildBuffChestTextures] 生成，3 个 key:
 *   chest-fire / chest-ice / chest-chain
 */
export default class BuffChest extends Phaser.GameObjects.Container {
  declare body: Phaser.Physics.Arcade.Body;
  /** 这个箱子代表的 buff 种类 —— MainScene 撞到后用它调 player.applyBulletBuff */
  readonly buffKind: BulletBuffKind;
  private _sprite: Phaser.GameObjects.Image;

  constructor(scene: Phaser.Scene, x: number, y: number, kind: BulletBuffKind) {
    super(scene, x, y);
    this.buffKind = kind;
    scene.add.existing(this);
    scene.physics.add.existing(this);

    const w = CHEST.width;
    const h = CHEST.height;
    const textureKey = kind === 'fire' ? 'chest-fire'
      : kind === 'ice'  ? 'chest-ice'
      : 'chest-chain';

    const shadow = scene.add.ellipse(0, h / 2 - 4, w * 0.85, 8, 0x000000, 0.3);
    this._sprite = scene.add.image(0, 0, textureKey);
    const baseScale = w / this._sprite.width;
    this._sprite.setScale(baseScale);

    // 加一圈与元素色匹配的脉动光晕，让玩家在远处一眼分辨
    const tint = BULLET_BUFF[kind].tint;
    const halo = scene.add.circle(0, 2, w * 0.7, tint, 0)
      .setStrokeStyle(2, tint, 0.7);
    scene.tweens.add({
      targets: halo,
      scale: { from: 0.85, to: 1.15 },
      alpha: { from: 0.9, to: 0.3 },
      duration: 700,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });

    this.add([shadow, halo, this._sprite]);

    this.body.setSize(w, h);
    this.body.setOffset(-w / 2, -h / 2);
    this.body.setAllowGravity(false);

    // 漂浮 + 闪一下
    scene.tweens.add({
      targets: this._sprite,
      y: { from: -2, to: 2 },
      duration: 700,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
    scene.tweens.add({
      targets: this._sprite,
      alpha: { from: 1, to: 0.85 },
      duration: 900,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
  }
}
